import { isIe } from './common';

function isEventSupported(elementName, eventName) {
    var element = document.createElement(elementName);
    return element['on' + eventName] !== undefined;
}

export function isInputFiredOnPlaceholderDelete(event) {
    return isIe() && event.type === 'input' && !event.target.hasAttribute('placeholder');
}

export var hasFocusinEvent = isEventSupported('div', 'focusin');
export var hasInputEvent = isEventSupported('input', 'input');



//////////////////
// WEBPACK FOOTER
// ./shared/modules/support.js
// module id = 8
// module chunks = main